import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HotPostsSection() {
  const hotPosts = articles.filter((a) => a.isHot).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              热门帖子
            </h2>
            <p className="text-sm text-foreground-500">社区最受关注的讨论话题</p>
          </div>
          <Link
            to="/category"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {hotPosts.map((post) => (
            <Link
              key={post.id}
              to={`/article/${post.id}`}
              className="group block p-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center gap-2 mb-3">
                {post.isPinned && (
                  <span className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium bg-accent-100 text-accent-600 rounded-full">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-pushpin-line text-[10px]"></i>
                    </div>
                    置顶
                  </span>
                )}
                <span className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium bg-primary-100 text-primary-600 rounded-full">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-fire-line text-[10px]"></i>
                  </div>
                  热门
                </span>
                <span className="text-xs text-foreground-400 ml-auto">{post.publishDate}</span>
              </div>

              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-3 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                {post.title}
              </h3>
              <p className="text-xs text-foreground-500 mb-4 line-clamp-2 leading-relaxed">
                {post.excerpt}
              </p>

              <div className="flex items-center justify-between text-xs text-foreground-400">
                <div className="flex items-center gap-3">
                  <span className="flex items-center gap-1">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-eye-line text-[10px]"></i>
                    </div>
                    {(post.views / 1000).toFixed(1)}k
                  </span>
                  <span className="flex items-center gap-1">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-chat-3-line text-[10px]"></i>
                    </div>
                    {post.replies}
                  </span>
                </div>
                <span className="text-foreground-500">{post.author}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}